import RestModel from './RestModel';

export default {
    login: (username, password) => RestModel.create('login', { username, password }),

    me: () => RestModel.list('me')
};
